import { App } from '@web/constants/app';
import { useMetadata } from '@web/query/Customer/useMetadata';
import { useLocaleStore } from '@web/store/App/useLocaleStore';
import { Company } from '@web/store/Company';
import React from 'react';

function SyncDefaultCountries() {
  const { data, isLoading } = useMetadata();

  const defaultCountries = Company.useCompany((state) => state.defaultCountries);

  // Track if initialization has already happened in this session
  const hasInitialized = React.useRef(false);

  React.useEffect(() => {
    // Only initialize once per session journey
    if (hasInitialized.current) return;
    if (isLoading) return;
    if (defaultCountries !== null) {
      hasInitialized.current = true;
      return;
    }

    let countries: AvailableCountries[] = [];

    if (data?.userMetadata?.defaultCountry && data?.userMetadata?.defaultCountry?.length > 0) {
      countries = data?.userMetadata?.defaultCountry;
    } else if (data?.metadata?.defaultCountry && data?.metadata?.defaultCountry?.length > 0) {
      countries = data?.metadata?.defaultCountry;
    } else {
      countries = [App.DefaultCountryKey];
    }

    // Set both defaultCountries and selectedCountry atomically
    Company.useCompany.setState({ defaultCountries: countries, selectedCountry: countries[0] as AvailableCountries });

    // Auto-derive locale from the primary default country (only if user hasn't explicitly chosen one)
    useLocaleStore.getState().initFromCountry(countries[0] as AvailableCountries);

    hasInitialized.current = true;
  }, [isLoading, data, defaultCountries]);

  return null;
}

export { SyncDefaultCountries };
